import React from "react";

import { LocaleConsumer } from "../Locale";

export interface IMoney {
  amount: number;
  currency: string;
}
export interface MoneyProps {
  money: IMoney;
}

export const ProductPrice: React.FC<MoneyProps> = ({ money }) => (
  <LocaleConsumer>
    {({ locale }) =>
      money.amount.toLocaleString(locale, {
        currency: money.currency,
        currencyDisplay: "symbol",
        style: "currency"
      })
    }
  </LocaleConsumer>
);

ProductPrice.displayName = "ProductPrice";
export default ProductPrice;
